import formModel from './formModel';

const {
    emailAddress,
    claimNumber,
    policyNumber,
    contactNumber,
    escalationNote,
    contactMethod,
    claimHandler,
} = formModel;

const initialValues = {
    [emailAddress.name]: '',
    [claimNumber.name]: '',
    [policyNumber.name]: '',
    [contactNumber.name]: '',
    [escalationNote.name]: '',
    [contactMethod.name]: '',
    [claimHandler.name]: '',
};

export default initialValues;
